<template>
  <div class="active-bar">
    <div class="left">
      <div class="time">{{ currentTime }}</div>
      <!-- <div class="filter">
        <span :class="[is_remake || is_limited || is_crossover ? 'inactive' : 'active']" @click="handleFilter()"
          >全部</span
        >
        <span :class="[is_remake ? 'active' : 'inactive']" @click="handleFilter('is_remake')">复刻</span>
        <span :class="[is_limited ? 'active' : 'inactive']" @click="handleFilter('is_limited')">限定</span>
        <span :class="[is_crossover ? 'active' : 'inactive']" @click="handleFilter('is_crossover')">联动</span>
      </div> -->
    </div>
    <div class="right">
      <div class="search-box">
        <input v-model="searchKey" class="input" type="text" placeholder="请输入活动名称" @input="onInput" />
        <img class="search-icon" src="@/assets/zs_imgs/wiki-icon-search.png" alt="搜索" />
      </div>
      <div class="divider"></div>
      <el-popover v-model="visible" placement="bottom" trigger="click" popper-class="__zsca-kachi-sort-popper-class__">
        <div slot="reference" class="sort-box">
          <img class="sort-icon" src="@/assets/zs_imgs/wiki-icon-filter.png" alt="排序" />
          <span class="sort-txt">{{ sortTxt }}</span>
        </div>
        <div ref="menuList" class="menu-list" @click="handleClickSort">
          <div class="menu-item" data-command="-1">从新到旧</div>
          <div class="divider"></div>
          <div class="menu-item" data-command="1">从旧到新</div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import dayjs from "@/plugins/dayjs";

export default {
  name: "ActiveBar",
  props: {
    keyword: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      timer: null,
      currentTime: "",
      searchKey: "",
      sortTxt: "从新到旧",
      is_crossover: false,
      is_limited: false,
      is_remake: false,
      visible: false
    };
  },
  watch: {
    keyword(value) {
      this.searchKey = value;
    }
  },
  mounted() {
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    updateTime() {
      this.currentTime = dayjs().format("YYYY-MM-DD HH:mm");
    },
    handleFilter(value) {
      this.clearFilter();
      if (value) {
        this[value] = true;
      }
      this.$emit("filter", value);
    },
    handleClickSort(event) {
      const command = event.target.dataset.command;
      if (!command) return;
      this.sortTxt = command === "-1" ? "从新到旧" : "从旧到新";
      this.visible = false;
      this.$emit("sort", command);
    },
    onInput() {
      this.$emit("input", this.searchKey);
    },
    clearFilter() {
      this.is_remake = false;
      this.is_limited = false;
      this.is_crossover = false;
    }
  }
};
</script>
<style>
.__zsca-kachi-sort-popper-class__ {
  background-color: var(--zs-kc-sortmenu-arrow-bg-color);
  padding: 0;
  border-color: var(--zs-kc-sortmenu-arrow-border-color);
  min-width: 100px;
}
.__zsca-kachi-sort-popper-class__ .popper__arrow {
  border-bottom-color: var(--zs-kc-sortmenu-arrow-border-color) !important;
  &::after {
    border-bottom-color: var(--zs-kc-sortmenu-arrow-bg-color) !important;
  }
}
</style>
<style lang="less" scoped>
.active-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    gap: 30px;
    .time {
      height: 29px;
      line-height: 29px;
      width: 138px;
      text-align: center;
      color: var(--zs-kc-currtime-font-color);
      border-radius: 20px;
      background-color: var(--zs-kc-currtime-bg-color);
      font-size: 12px;
    }
    .filter {
      display: flex;
      gap: 20px;
      font-size: 12px;
      visibility: hidden;
      .active {
        cursor: pointer;
        color: var(--zs-kc-filter-active-font-color);
        font-weight: bold;
      }
      .inactive {
        cursor: pointer;
        color: var(--zs-kc-filter-inactive-font-color);
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    gap: 16px;
    .search-box {
      position: relative;
      .input {
        box-sizing: content-box;
        width: 188px;
        background-color: transparent;
        color: var(--zs-kc-searchinput-font-color);
        border: none;
        font-size: 12px;
        border-bottom: 1px solid var(--zs-kc-searchinput-border-color);
        padding: 4px 12px 4px 6px;
        &::placeholder {
          color: var(--zs-kc-searchinput-placeholder-color);
        }
      }
      .search-icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        color: var(--zs-kc-searchinput-icon-color);
        width: 12px;
        height: 12px;
      }
    }
    .divider {
      width: 1px;
      height: 18px;
      background-color: var(--zs-kc-divider-color);
    }
    .sort-box {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      .sort-icon {
        color: var(--zs-kc-sort-icon-color);
        width: 16px;
        height: 16px;
      }
      .sort-txt {
        color: var(--zs-kc-sort-txt-color);
        font-size: 12px;
      }
    }
  }
}
.menu-list {
  color: var(--zs-kc-sortmenu-font-color);
  background-color: var(--zs-kc-sortmenu-bg-color);
  font-size: 12px;
  .divider {
    width: 84px;
    margin: 0 8px;
    height: 1px;
    background-color: var(--zs-kc-sortmenu-divider-color);
  }
  .menu-item {
    cursor: pointer;
    padding: 10px 0;
    text-align: center;
  }
}
</style>
